<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="行业名称">-->
<!--                  <el-input  v-model="queryForm.industryName"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopShopIndustryList">查询</el-button>-->
<!--                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>-->
<!--              </el-form-item>-->
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopShopIndustry"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editShopShopIndustry(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopShopIndustry(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
<!--        <span-->
<!--          title="搜索"-->
<!--          class="icon-box"-->
<!--          @click="search"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <Search />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshShopShopIndustryList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopShopIndustryList"
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="industryName"
        label="行业名称"
      > </el-table-column>
<!--      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="parentId"
        label="父类"
      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
      >
          <template slot-scope="scop">
              <el-input-number
                  style="width:150px"
                  v-model="scop.row.sort"
                  @change="changeSort(scop.row)"
                  size="small"
                  label=""
                  :min="1"
                  :max="1000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="400"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopShopIndustry(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopShopIndustry(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopShopIndustry(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
              <div @click="addChildProductCategory(scop.row.id)">
                  <Icon size="16">
                      <AddCircle24Regular />
                  </Icon>
                  <span class="operation-label">添加下级商品分类</span>
              </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopShopIndustryStates[shopShopIndustryState]"
      :visible.sync="showDialog"
      width="400px"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopShopIndustry"
          ref="shopShopIndustryForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="行业名称"
            prop="industryName"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopShopIndustry.industryName"
              :disabled="shopShopIndustryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="父类"
            prop="parentId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopShopIndustry.parentId"-->
<!--              :disabled="shopShopIndustryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 200px"
                  v-model="shopShopIndustry.parentId"
                  placeholder="请选择"
                  :disabled="shopShopIndustryState == 'check'"
                  size="small"
              >
                  <el-option
                      label="顶级分类"
                      :value="'0'"
                  ></el-option>
                  <el-tree
                      :data="shopShopIndustryList"
                      :props="treeProps"
                      :render-after-expand="false"
                  >
                      <div
                          class="custom-tree-node flex items-center"
                          slot-scope="{ node, data }"
                      >
                          <el-option
                              :label="node.label"
                              :value="data.id"
                          ></el-option>
                      </div>
                  </el-tree>
              </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopShopIndustry.sort"-->
<!--              :disabled="shopShopIndustryState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 200px"
                  :disabled="shopShopIndustryState == 'check'"
                  v-model="shopShopIndustry.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopShopIndustryState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular, AddCircle24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        AddCircle24Regular
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopShopIndustryList();
                    this.getShopShopIndustryList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopShopIndustryList();
                    this.getShopShopIndustryList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     industryName: '', //行业名称
                     parentId: '', //父亲
                     sort: '', //排序
                },
                treeProps: {
                    children: 'children',
                    label: 'industryName'
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopShopIndustryState: 'add',
                shopShopIndustryStates: {
                    add: '新建行业分类',
                    check: '查看行业分类',
                    edit: '修改行业分类',
                    addChild: '添加下级行业分类'
                },

                multipleSelection: [],
                shopShopIndustryList: [],
                shopShopIndustry: {
                    id: '', //
                    industryName: '', //行业名称
                    parentId: '', //父亲
                    sort: '', //排序
                },
                btnLoading: false,

                rules: {
                    industryName: [{ required: true, message: '行业名称不能为空', trigger: 'blur' }],
                    parentId: [{ required: true, message: '父亲不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getShopShopIndustryList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetShopShopIndustryList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopShopIndustryList = [];
            },
            changeSort(category) {
                delete category.children;
                post(`/shop/shopindustry/edit`, { ...category }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: `编辑成功`,
                            type: 'success',
                            duration: 2000
                        });
                        this.getShopShopIndustryList();
                    }
                });
            },
            addChildProductCategory(departmentId) {
                this.shopShopIndustry.parentId = departmentId;
                this.showDialog = true;
                this.shopShopIndustryState = 'addChild';
            },
            resetDialog() {
                this.shopShopIndustryState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      industryName: '', //行业名称
                      parentId: '', //父亲
                      sort: '', //排序
                };
                this.getShopShopIndustryList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopShopIndustry = {
                      id: '', //
                      industryName: '', //行业名称
                      parentId: '', //父亲
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.shopShopIndustryState == 'add'  || this.shopShopIndustryState == 'addChild') {
                    this.$refs.shopShopIndustryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/shopindustry/add`,{ ...this.shopShopIndustry }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopShopIndustryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopShopIndustryState == 'edit') {
                    this.$refs.shopShopIndustryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopShopIndustry.children;
                            post(`/shop/shopindustry/edit`,{ ...this.shopShopIndustry }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopShopIndustryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopShopIndustry() {
                this.showDialog = true;
                this.shopShopIndustryState = 'add';
            },
            checkShopShopIndustry(shopShopIndustryId) {
                console.log(shopShopIndustryId);
                this.currentShopShopIndustryId = shopShopIndustryId;

                this.getShopShopIndustryById();
                this.showDialog = true;
                this.shopShopIndustryState = 'check';
            },
            editShopShopIndustry(shopShopIndustryId) {
                console.log('shopShopIndustry', shopShopIndustryId);
                if (shopShopIndustryId) {
                    this.currentShopShopIndustryId = shopShopIndustryId;
                    this.getShopShopIndustryById();
                } else {
                    this.shopShopIndustry = { ...this.shopShopIndustry, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopShopIndustryState = 'edit';
            },
            deleteShopShopIndustry(shopShopIndustryId) {
                let ids = '';
                if (shopShopIndustryId) {
                    ids = shopShopIndustryId;
                } else {
                    ids = this.multipleSelection.map((shopShopIndustry) => shopShopIndustry.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/shopindustry/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopShopIndustryList();
                                this.getShopShopIndustryList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopShopIndustryList() {
                this.resetShopShopIndustryList();
                this.getShopShopIndustryList();
            },
            getShopShopIndustryList(query = {}) {
                this.loading = true;
                get(`/shop/shopindustry/findAllAsTree`).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopShopIndustryList = res.treeData;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopShopIndustryById() {
                get(`/shop/shopindustry/get`,{ id: this.currentShopShopIndustryId }).then((res) =>{
                    if(res.success){
                      this.shopShopIndustry = { ...this.shopShopIndustry, ...res.shopShopIndustry };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopShopIndustryList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/shopindustry/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/shopindustry/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/shopindustry/importData`,formData);
              this.refreshShopShopIndustryList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopShopIndustryList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopShopIndustryList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>